import { Link } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import type { ActivityItem } from '../hooks/useMyActivity'

function formatDate(d: Date): string {
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
}

function formatMoney(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`
}

export function ActivityItemCard({ item }: { item: ActivityItem }) {
  if (item.kind === 'engagement') {
    const e = item.data
    return (
      <Link to="/dashboard?tab=activity" className="block">
        <Card>
          <CardContent className="flex items-start justify-between gap-4 p-4">
            <div>
              <p className="text-xs uppercase tracking-wide text-muted-foreground">Service</p>
              <p className="font-medium">{e.title}</p>
              <p className="text-sm text-muted-foreground">{formatDate(item.date)}</p>
            </div>
            <Badge variant="secondary">{e.status.replace(/_/g, ' ')}</Badge>
          </CardContent>
        </Card>
      </Link>
    )
  }

  if (item.kind === 'ticket-order') {
    const o = item.data
    return (
      <Link to="/dashboard?tab=activity" className="block">
        <Card>
          <CardContent className="flex items-start justify-between gap-4 p-4">
            <div>
              <p className="text-xs uppercase tracking-wide text-muted-foreground">Tickets</p>
              <p className="font-medium">{o.eventTitle}</p>
              <p className="text-sm text-muted-foreground">
                {formatDate(item.date)} · Order #{o.id.slice(0, 8).toUpperCase()}
              </p>
            </div>
            <Badge>{o.status}</Badge>
          </CardContent>
        </Card>
      </Link>
    )
  }

  const o = item.data
  return (
    <Card>
      <CardContent className="flex items-start justify-between gap-4 p-4">
        <div>
          <p className="text-xs uppercase tracking-wide text-muted-foreground">Shop order</p>
          <p className="font-medium">Order #{o.id.slice(0, 8).toUpperCase()}</p>
          <p className="text-sm text-muted-foreground">
            {formatDate(item.date)} · {formatMoney(o.totalCents)}
          </p>
        </div>
        <Badge variant="secondary">{o.status.replace(/_/g, ' ')}</Badge>
      </CardContent>
    </Card>
  )
}
